<mat-card>
  <mat-card-header>
    <mat-card-title>Karte 2</mat-card-title>
  </mat-card-header>
  <mat-card-subtitle>
    <hr />
  </mat-card-subtitle>
  <mat-card-content>
    Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis saepe minus consectetur,
    ratione porro earum nihil dolores quo est inventore fugiat tempora accusantium facere error. Beatae officiis
    aperiam quam nostrum?
    Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis saepe minus consectetur,
    ratione porro earum nihil dolores quo est inventore fugiat tempora accusantium facere error. Beatae officiis
    aperiam quam nostrum?
  </mat-card-content>
</mat-card>